import React from "react";
import styles from "./styles.scss";
import { Skeleton } from "@common/skeleton";

function Status() {
  return (
    <div className={styles.status}>
      <Skeleton className={styles.item} />
    </div>
  );
}

export { Status };
